<template>
	<div class="ic-window" :class="{ 'opened': isOpen, 'closed': !isOpen }">
		<section class="ic-header-container">
			<PanelHeader
						v-if="showHeader"
						:title="title"
						@close="$emit('close')">

				<slot name="header"></slot>
			</PanelHeader>
		</section>

		<div class="ic-body-container">

			<slot></slot>

		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PanelHeader from './Header.vue'

export default defineComponent({
	name: "IntercomPanel",
	emits: ['close'],
	components: { PanelHeader },
	props: {
		isOpen: {
			type: Boolean,
			default: () => false
		},
		showHeader: {
			type: Boolean,
			default: true
		},
		title: String
	}
})

</script>

<style scoped>
.ic-window {
	overflow: hidden;
	width: 370px;
	min-height: 300px;
	max-height: calc(100vh - 140px);
	height: 590px;
	position: fixed;
	z-index: 999999;
	right: 25px;
	bottom: 100px;
	box-sizing: border-box;
	box-shadow: 0 0 3px 1px rgb(0 0 0 / 20%),
		0px 7px 40px 2px rgba(148, 149, 150, 0.1);
	background: white;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	border-radius: 10px;
	font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
	animation: fadeIn .1s ease-in-out;
	transform-origin: bottom right;
}

.ic-window.closed {
	opacity: 0;
	display: none;
}

@keyframes fadeIn {
	0% {
		transform: scale(0);
		opacity: 0;
	}

	100% {
		display: flex;
		transform: scale(1);
		opacity: 1;
	}
}

.ic-header-container {
	flex: 0 0 75px;
}

.ic-body-container {
	flex: 1 1 100%;
	height: 100%;
	overflow-y: auto;
}

@media (max-width: 720px) {
	.ic-window {
		width: 100%;
		height: 100%;
		max-height: 100%;
		right: 0px;
		bottom: 0px;
		border-radius: 0px;
	}

	.ic-window {
		transition: 0.1s ease-in-out;
	}

	.ic-window.closed {
		bottom: 0px;
	}
}
</style>
